export default {"src":"/_next/static/media/paypal-logo.c3c9be40.svg","height":60,"width":246,"blurWidth":0,"blurHeight":0};